import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Anchor, Menu, Icon, Dropdown } from 'antd';
import { currencyMap, businessMap, researchMap } from './config';
import textImg from '../../asset/img/text.png';
import logo from '../../asset/img/logo.png';
import { login, logout, getUserInfo } from '../../redux/action/auth/auth';
import getUrlParam from '../../lib/getUrlParam';
import getCookie from '../../lib/getCookie';
import { ssoUrl } from '../../lib/ssoPath';
import styles from './index.module.scss';

const { Link } = Anchor;

const Home = $$ => {
  const code = getUrlParam('code') || '';

  const [key, setKey] = useState('#part-1');
  const [flag, setFlag] = useState(false);

  const windowWidth = window.innerWidth;

  // mount
  useEffect(() => {
    async function mounted() {
      if (getCookie('token')) {
        $$.getUserInfo();
      } else if (code) {
        await $$.login(code);
        const path = window.location.href.split('?');
        path.length === 2 ? window.location.replace(path[0]) : false;
      }
    }
    mounted();
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const scrollDistance = window.scrollY;
      const windowidth = window.innerWidth;
      if (windowidth > 750) {
        if (scrollDistance > 300) {
          setFlag(true);
        } else {
          setFlag(false);
        }
      } else if (scrollDistance > 180) {
        setFlag(true);
      } else {
        setFlag(false);
      }

      // 在这里处理滚动距离的逻辑
    };

    window.addEventListener('scroll', handleScroll);

    // 清除事件监听器，避免在组件卸载后继续触发事件
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // 空数组作为依赖项，表示只在组件挂载时执行一次

  // 登录
  const loginIn = () => {
    if (getCookie('token')) {
      $$.getUserInfo();
    } else if (code) {
      $$.login(code);
    } else {
      window.location.href = ssoUrl;
    }
  };

  const menu = (
    <Menu>
      <Menu.Item
        onClick={() => {
          $$.logout();
        }}
      >
        <div>
          <Icon type="logout" /> 退出登录
        </div>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className={styles.homePage}>
      {!flag && (
        <div className={styles.headerNav}>
          <div className={styles.nav}>
            <div className={styles.logo}>
              <img src={logo} alt="logo" />
            </div>
            <div
              className={styles.login}
              onClick={() => {
                !$$.userId && loginIn();
              }}
            >
              {$$.loginStatus ? (
                <Dropdown overlay={menu} trigger={['click']}>
                  <span className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                    {!!$$.userId ? `用户：${$$.userName||$$.userId}` : '已登录'}
                  </span>
                </Dropdown>
              ) : (
                '登录'
              )}
            </div>
          </div>
        </div>
      )}
      <div className={styles.bannerModule}>
        <div className={styles.textWrap}>
          <img src={textImg} alt="text" />
        </div>

        <div className={` ${flag ? styles.tabTop : styles.tabWrap}`}>
          <Anchor
            bounds={windowWidth > 768 ? 60 : 0}
            offsetTop={windowWidth > 768 ? 100 : 60}
            onChange={e => {
              setKey(e || '#part-1');
            }}
          >
            <Link
              href="#part-1"
              className={`${key === '#part-1' && styles.active}`}
              title="通用类"
            />
            <Link
              href="#part-2"
              className={`${key === '#part-2' && styles.active} ${styles.part}`}
              title="业务类"
            />
            <Link
              href="#part-3"
              className={`${key === '#part-3' && styles.active}`}
              title="系统研发类"
            />
          </Anchor>
        </div>
      </div>
      <div className={styles.homeContainer}>
        <div className={styles.homeContent}>
          <div className={styles.currencyModule} id="part-1">
            <div className={styles.name}>通用类</div>
            <div className={styles.currencyContent}>
              {currencyMap.map(item => {
                return (
                  <div
                    className={styles.navagation}
                    onClick={() => {
                      window.open(item.url);
                    }}
                  >
                    <div className={styles.img}>
                      <img src={item.img} alt={item.title} />
                    </div>
                    <div className={styles.text}>
                      <div className={styles.title}> {item.title}</div>
                      <div className={styles.subTitle}> {item.subTitle}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className={styles.businessModule} id="part-2">
            <div className={styles.name}>业务类</div>
            <div className={styles.businessContent}>
              {businessMap.map(item => {
                return (
                  <div
                    className={styles.navagation}
                    onClick={() => {
                      window.open(item.url);
                    }}
                  >
                    <div className={styles.img}>
                      <img src={item.img} alt={item.title} />
                    </div>
                    <div className={styles.text}>
                      <div className={styles.title}> {item.title}</div>
                      <div className={styles.subTitle}> {item.subTitle}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className={styles.researchModule} id="part-3">
            <div className={styles.name}>系统研发类</div>
            <div className={styles.researchContent}>
              {researchMap.map(item => {
                return (
                  <div
                    className={styles.navagation}
                    onClick={() => {
                      window.open(item.url);
                    }}
                  >
                    <div className={styles.img}>
                      <img src={item.img} alt={item.title} />
                    </div>
                    <div className={styles.text}>
                      <div className={styles.title}> {item.title}</div>
                      <div className={styles.subTitle}> {item.subTitle}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Copyright@ {new Date().getFullYear() || '2023'}上海网鱼信息科技有限公司
      </div>
    </div>
  );
};
const mapStateToProps = state => {
  const { userName, userId, loginStatus } = state.auth;
  return { userName, userId, loginStatus };
};

export default connect(mapStateToProps, { login, logout, getUserInfo })(Home);
